import {
  trainingConverter,
  energyConverter,
  sheddingConverter,
  sizeConverter,
} from "@utils"
import s from "./Facts.module.scss"

const Facts = ({ breed }) => {
  if (!breed || Object.entries(breed).length === 0) return null

  const {
    name,
    description,
    lifeSpanMax,
    lifeSpanMin,
    weightMax,
    weightMin,
    temperament,
    easyToTrain,
    energyLevel,
    amountOfShedding,
    size,
  } = breed

  const facts = [
    {
      img: "/facts/weight.svg",
      title: "Weight",
      alt: "Weight icon in pounds",
      value: `${weightMin} - ${weightMax} lbs`,
    },
    {
      img: "/facts/type.svg",
      title: "Size",
      alt: "Dog icon",
      value: `${sizeConverter(size)}`,
    },
    {
      img: "/facts/energy.svg",
      title: "Energy",
      alt: "Thunderbolt icon",
      value: `${energyConverter(energyLevel)}`,
    },
    {
      img: "/facts/shedding.svg",
      title: "Shedding",
      alt: "Dog shedder icon",
      value: `${sheddingConverter(amountOfShedding)}`,
    },
    {
      img: "/facts/training.svg",
      title: "Trainability",
      alt: "Badge icon",
      value: `${trainingConverter(easyToTrain)}`,
    },
    {
      img: "/facts/life-span.svg",
      title: "Life span",
      alt: "Heart beat icon",
      value: `${lifeSpanMin} to ${lifeSpanMax} years`,
    },
  ]

  const frenchDescription = (
    <p>
      French Bulldogs are small, reasonably independent and clever—all
      attributes that make them some of the{" "}
      <a href="https://www.mawoopets.com/blog/best-apartment-dogs">
        best apartment dogs
      </a>
      . Frenchies are also affectionate with their families, and good with kids
      and other dogs. Easygoing and adaptable, these dogs are a good choice for
      owners without a lot of experience handling and training pets.
    </p>
  )

  const information =
    name === "French Bulldog" ? (
      <div>{frenchDescription}</div>
    ) : (
      <p>{description}</p>
    )

  const breedTemperament = (
    <>
      <br />
      <br />
      <b>Temperament</b>
      <br />
      {temperament}
    </>
  )

  return (
    <div className={s.factsBackground}>
      <div className={s.factsContainer}>
        <div className={s.factsText}>
          <h2>{name} Breed Information</h2>
          {information}
          <p>{temperament && breedTemperament}</p>
        </div>

        <div className={s.facts}>
          <div className={s.factsHeader}>
            <p>Breed Fast Facts</p>
          </div>

          <div className={s.info}>
            {facts.map((fact, i) => {
              return (
                <div key={i} className={s.fact}>
                  <img src={fact.img} alt={fact.alt} width={20} height={20} />
                  <h5>{fact.title}</h5>
                  <p>{fact.value}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Facts
